<template>
<v-container id="tour-countdown" text-xs-center>
  <countdown :time="timeToOpen" auto-start ref="countdown">
    <template class="text-uppercase" slot-scope="props">
      <div>
        <span>
          Your Tour will be accessible in:
        </span>
      </div>
      <div>
        <span>{{ props.days }} days</span>
      </div>
      <div>
        <span>{{ props.hours }} hours</span>
      </div>
      <div>
        <span>{{ props.minutes }} minutes</span>
      </div>
      <div>
        <span>{{ props.seconds }} seconds</span>
      </div>
    </template>
  </countdown>
</v-container>
</template>

<script>
import VueCountdown from '@xkeshi/vue-countdown'

export default {
  name: 'tour-countdown',
  components: {
    "countdown": VueCountdown
  },
  props: {
    'tourOpen': {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      timeToOpen: this.tourOpen
    }
  }
}
</script>

<style scoped>
#tour-countdown {
  font-family: 'BebasNeue-Regular';
  font-size: 36px;
  position: absolute;
  top: 100px;
  bottom: auto;
}
</style>
